import { hdcAutoPayAlertMock } from "../builders/createInsuranceBill";
import { cigHdcAutoPayFailedBill } from "../builders/createCigBill";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { legacyCanadaSecondGearMember } from "../mockMembers";
import { mockPolicies } from "../mockPolicies";

import { MockPersona } from "./mockPersonas.types";

export const johnDoe: MockPersona = {
  key: "johnDoe",
  name: "John Doe",
  description: "🇨🇦 | One core policy | HDC 1.0 Single-tier | HDC Autopay failed",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcAutoPayFailedBill("1.0", {})],
      },
      policies: {
        usa: [],
        canada: [mockPolicies["MC934852-01"]],
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB2" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "john@doe.com",
            firstName: "John",
            middleName: "Nicholas",
            lastName: "Doe",
            mailingAddress: {
              line1: "361 Yonge Street",
              line2: "",
              city: "Toronto",
              state: "ON",
              postalCode: "M5B 1M4",
              country: "CANADA",
            },
            preferredPhone: "4167820924",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000014",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyCanadaSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcAutoPayAlertMock()],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
